import React, { forwardRef } from 'react';
import MDButtonRoot from './MDButtonRoot';
import { useTheme } from '@mui/material/styles';
import { FFTheme } from 'assets/theme';
import { ButtonProps } from '@mui/material';

type MDButtonProps = Omit<ButtonProps, 'color' | 'variant'> & {
  color?:
    | 'white'
    | 'primary'
    | 'secondary'
    | 'info'
    | 'success'
    | 'warning'
    | 'error'
    | 'light'
    | 'dark';
  variant?: 'text' | 'contained' | 'outlined' | 'gradient';
  size?: 'small' | 'medium' | 'large';
  circular?: boolean;
  iconOnly?: boolean;
  children: React.ReactNode;
};

const MDButton = forwardRef<HTMLButtonElement, MDButtonProps>(
  (
    {
      color = 'white',
      variant = 'contained',
      size = 'medium',
      circular = false,
      iconOnly = false,
      children,
      ...rest
    },
    ref
  ) => {
    // const [controller] = useMaterialUIController();
    // const { darkMode } = controller;
    const theme = useTheme<FFTheme>();

    return (
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      <MDButtonRoot
        {...rest}
        ref={ref}
        theme={theme}
        color="primary"
        variant={variant === 'gradient' ? 'contained' : variant}
        size={size}
        ownerState={{ color, variant, size, circular, iconOnly }} /**darkMode */
      >
        {children}
      </MDButtonRoot>
    );
  }
);

MDButton.displayName = 'MDButton';

export { MDButton };
